export default __webpack_public_path__ + "static/TransUnion-e31a40fe78699ce95eaf84ff0c4cdc08.svg";